// extracted by mini-css-extract-plugin
export var prospectNavBarContainer = "ProspectNavBar_prospectNavBarContainer__bPdll";
export var prospectNavBarContainerShop = "ProspectNavBar_prospectNavBarContainerShop__oLT2f";